const fakeVefData = [
  {
    voyageNumber: "2025-030",
    date: "2025-10-01",
    loadPort: "Göteborg",
    cargo: "Diesel",
    shipLoaded: 24500,
    shoreBL: 24400,
    diff: 100,
    basis: "Shore",
    rejected: "No",
    comment: "Slight diff, within tolerance",
  },
  {
    voyageNumber: "2025-029",
    date: "2025-09-25",
    loadPort: "Stockholm",
    cargo: "Gasoline",
    shipLoaded: 19850,
    shoreBL: 19800,
    diff: 50,
    basis: "Shore",
    rejected: "No",
    comment: "",
  },
  {
    voyageNumber: "2025-028",
    date: "2025-09-12",
    loadPort: "Lysekil",
    cargo: "Crude Oil",
    shipLoaded: 51000,
    shoreBL: 51400,
    diff: -400,
    basis: "Shore",
    rejected: "No",
    comment: "Large diff, not qualified",
  },
  {
    voyageNumber: "2025-027",
    date: "2025-08-30",
    loadPort: "Karlshamn",
    cargo: "Fuel Oil",
    shipLoaded: 30200,
    shoreBL: 30190,
    diff: 10,
    basis: "Shore",
    rejected: "No",
    comment: "",
  },
  {
    voyageNumber: "2025-026",
    date: "2025-08-12",
    loadPort: "Malmö",
    cargo: "Jet A1",
    shipLoaded: 15000,
    shoreBL: 15020,
    diff: -20,
    basis: "Shore",
    rejected: "No",
    comment: "Within acceptable range",
  },
  {
    voyageNumber: "2025-025",
    date: "2025-07-30",
    loadPort: "Nynäshamn",
    cargo: "Gasoline",
    shipLoaded: 19900,
    shoreBL: 19910,
    diff: -10,
    basis: "Shore",
    rejected: "No",
    comment: "",
  },
  {
    voyageNumber: "2025-024",
    date: "2025-07-10",
    loadPort: "Brofjorden",
    cargo: "Crude Oil",
    shipLoaded: 51200,
    shoreBL: 51100,
    diff: 100,
    basis: "Shore",
    rejected: "No",
    comment: "",
  },
  {
    voyageNumber: "2025-023",
    date: "2025-06-28",
    loadPort: "Gävle",
    cargo: "Fuel Oil",
    shipLoaded: 30500,
    shoreBL: 30450,
    diff: 50,
    basis: "Shore",
    rejected: "No",
    comment: "",
  },
  {
    voyageNumber: "2025-022",
    date: "2025-06-10",
    loadPort: "Helsingborg",
    cargo: "Diesel",
    shipLoaded: 24800,
    shoreBL: 24850,
    diff: -50,
    basis: "Shore",
    rejected: "No",
    comment: "",
  },
  {
    voyageNumber: "2025-021",
    date: "2025-05-25",
    loadPort: "Stockholm",
    cargo: "Gasoline",
    shipLoaded: 20000,
    shoreBL: 19960,
    diff: 40,
    basis: "Shore",
    rejected: "No",
    comment: "",
  },
  {
    voyageNumber: "2025-020",
    date: "2025-05-12",
    loadPort: "Lysekil",
    cargo: "Crude Oil",
    shipLoaded: 51200,
    shoreBL: 51450,
    diff: -250,
    basis: "Shore",
    rejected: "No",
    comment: "Slightly outside range",
  },
  {
    voyageNumber: "2025-019",
    date: "2025-04-29",
    loadPort: "Karlshamn",
    cargo: "Fuel Oil",
    shipLoaded: 30100,
    shoreBL: 30100,
    diff: 0,
    basis: "Shore",
    rejected: "No",
    comment: "",
  },
  {
    voyageNumber: "2025-018",
    date: "2025-04-15",
    loadPort: "Malmö",
    cargo: "Jet A1",
    shipLoaded: 15010,
    shoreBL: 15000,
    diff: 10,
    basis: "Shore",
    rejected: "No",
    comment: "",
  },
  {
    voyageNumber: "2025-017",
    date: "2025-04-02",
    loadPort: "Brofjorden",
    cargo: "Crude Oil",
    shipLoaded: 51100,
    shoreBL: 51200,
    diff: -100,
    basis: "Shore",
    rejected: "No",
    comment: "",
  },
  {
    voyageNumber: "2025-016",
    date: "2025-03-18",
    loadPort: "Göteborg",
    cargo: "Diesel",
    shipLoaded: 24400,
    shoreBL: 24410,
    diff: -10,
    basis: "Shore",
    rejected: "No",
    comment: "",
  },
  {
    voyageNumber: "2025-015",
    date: "2025-03-01",
    loadPort: "Stockholm",
    cargo: "Gasoline",
    shipLoaded: 19800,
    shoreBL: 19900,
    diff: -100,
    basis: "Ship",
    rejected: "No",
    comment: "",
  },
  {
    voyageNumber: "2025-014",
    date: "2025-02-20",
    loadPort: "Lysekil",
    cargo: "Crude Oil",
    shipLoaded: 51300,
    shoreBL: 51400,
    diff: -100,
    basis: "Shore",
    rejected: "No",
    comment: "",
  },
  {
    voyageNumber: "2025-013",
    date: "2025-02-08",
    loadPort: "Karlshamn",
    cargo: "Fuel Oil",
    shipLoaded: 30210,
    shoreBL: 30190,
    diff: 20,
    basis: "Shore",
    rejected: "No",
    comment: "",
  },
  {
    voyageNumber: "2025-012",
    date: "2025-01-25",
    loadPort: "Malmö",
    cargo: "Jet A1",
    shipLoaded: 14990,
    shoreBL: 15010,
    diff: -20,
    basis: "Shore",
    rejected: "No",
    comment: "",
  },
  {
    voyageNumber: "2025-011",
    date: "2025-01-10",
    loadPort: "Brofjorden",
    cargo: "Crude Oil",
    shipLoaded: 51000,
    shoreBL: 51400,
    diff: -400,
    basis: "Shore",
    rejected: "Yes",
    comment: "Rejected due to large diff",
  },
  {
    voyageNumber: "2024-010",
    date: "2024-12-20",
    loadPort: "Gävle",
    cargo: "Fuel Oil",
    shipLoaded: 30500,
    shoreBL: 30480,
    diff: 20,
    basis: "Shore",
    rejected: "No",
    comment: "",
  },
  {
    voyageNumber: "2024-009",
    date: "2024-12-05",
    loadPort: "Göteborg",
    cargo: "Diesel",
    shipLoaded: 24500,
    shoreBL: 24450,
    diff: 50,
    basis: "Shore",
    rejected: "No",
    comment: "",
  },
  {
    voyageNumber: "2024-008",
    date: "2024-11-22",
    loadPort: "Stockholm",
    cargo: "Gasoline",
    shipLoaded: 19900,
    shoreBL: 19900,
    diff: 0,
    basis: "Shore",
    rejected: "No",
    comment: "",
  },
  {
    voyageNumber: "2024-007",
    date: "2024-11-06",
    loadPort: "Lysekil",
    cargo: "Crude Oil",
    shipLoaded: 51450,
    shoreBL: 51400,
    diff: 50,
    basis: "Shore",
    rejected: "No",
    comment: "",
  },
  {
    voyageNumber: "2024-006",
    date: "2024-10-25",
    loadPort: "Karlshamn",
    cargo: "Fuel Oil",
    shipLoaded: 30100,
    shoreBL: 30120,
    diff: -20,
    basis: "Shore",
    rejected: "No",
    comment: "",
  },
  {
    voyageNumber: "2024-005",
    date: "2024-10-10",
    loadPort: "Malmö",
    cargo: "Jet A1",
    shipLoaded: 15000,
    shoreBL: 15000,
    diff: 0,
    basis: "Shore",
    rejected: "No",
    comment: "",
  },
  {
    voyageNumber: "2024-004",
    date: "2024-09-25",
    loadPort: "Brofjorden",
    cargo: "Crude Oil",
    shipLoaded: 51200,
    shoreBL: 51400,
    diff: -200,
    basis: "Shore",
    rejected: "No",
    comment: "",
  },
  {
    voyageNumber: "2024-003",
    date: "2024-09-10",
    loadPort: "Gävle",
    cargo: "Fuel Oil",
    shipLoaded: 30500,
    shoreBL: 30520,
    diff: -20,
    basis: "Shore",
    rejected: "No",
    comment: "",
  },
  {
    voyageNumber: "2024-002",
    date: "2024-08-20",
    loadPort: "Göteborg",
    cargo: "Diesel",
    shipLoaded: 24350,
    shoreBL: 24300,
    diff: 50,
    basis: "Shore",
    rejected: "No",
    comment: "",
  },
  {
    voyageNumber: "2024-001",
    date: "2024-08-05",
    loadPort: "Stockholm",
    cargo: "Gasoline",
    shipLoaded: 19800,
    shoreBL: 19900,
    diff: -100,
    basis: "Shore",
    rejected: "No",
    comment: "",
  },
];

export default fakeVefData;
